/**************************************************
 * Nombre:       Tarjeta_Preguntas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Collapse, Grid, IconButton, Typography} from "@mui/material";
import {Add, Remove} from '@mui/icons-material'

const Tarjeta_Preguntas = ({escogido, setEscogido, item}) => {


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                onClick={() => item.pregunta === escogido ? setEscogido({}) : setEscogido(item.pregunta)}
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    backgroundColor: 'white',
                    px: 2,
                    py: 1,
                    border: 1,
                    borderColor: '#E3D9F7',
                    borderRadius: 2
                }}
            >

                <Grid container size={{xs: 11, sm: 11, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontWeight: 600}}>{item.pregunta}</Typography>
                </Grid>

                <Grid container size={{xs: 1, sm: 1, md: 1}} sx={{justifyContent: 'flex-start'}}>
                    <IconButton
                        onClick={() => item.pregunta === escogido ? setEscogido({}) : setEscogido(item.pregunta)}
                    >

                        {escogido === item.pregunta ?

                            <Remove/>
                            :
                            <Add/>

                        }

                    </IconButton>
                </Grid>

                <Collapse in={escogido === item.pregunta} sx={{width: '100%'}}>
                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Typography sx={{fontSize: 14, fontWeight: 300}}>
                            {item.respuesta}
                        </Typography>
                    </Grid>
                </Collapse>

            </Grid>


        </Grid>
    )

}
export default Tarjeta_Preguntas